import { useGetCustomerAccountCapabilitiesQuery } from "@/generated/redux/services/generated/api";
import { useCustomerAccount } from "@/providers";

// Stable empty fallback so consumers that memoize on these arrays don't
// recompute every render while the query is loading.
const EMPTY_LIST: readonly never[] = [];

/**
 * Hook to fetch customer account capabilities from the BFF.
 * Returns tradable products (for exchange) and payable products (for payments).
 */
export function useCapabilities() {
  const { customerAccount } = useCustomerAccount();
  const customerAccountId = customerAccount?.customerAccount?.id;

  const { data, isLoading, isError, refetch } =
    useGetCustomerAccountCapabilitiesQuery(
      { customerAccountId: customerAccountId as string },
      { skip: !customerAccountId }
    );

  return {
    tradable: data?.tradable ?? (EMPTY_LIST as never[]),
    payable: data?.payable ?? (EMPTY_LIST as never[]),
    isLoading,
    isError,
    refetch,
  };
}
